/**
 * In this file contains the Sidebar screen UI designs and login Sidebar functionality
 **/
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import Socket from "./../../services/SocketService";
import { useDispatch } from "react-redux";
import constantVariables from "./../../dataset/constantVariables.json";
import { useTranslation } from 'react-i18next';
import { useEffect,useState } from "react";

function Sidebar(isOpen) {
  //Intial state declaration
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation(); // Get the current location
  const role = parseInt(localStorage.getItem("role"));
  const { t } = useTranslation();
  const [openDropdowns, setOpenDropdowns] = useState({
    vaccinationSchedule: false, //Add this line
  });

  // Function to toggle a dropdown menu
  const toggleDropdown = (menuName, event) => {
    if (event) event.preventDefault();

    setOpenDropdowns((prev) => ({
      ...prev,
      [menuName]: !prev[menuName], // Toggle specific dropdown
    }));
  };
  //Logout function
  const logout = () => {
    Socket.disconnect();
    navigate("/");
    localStorage.clear();
    dispatch({ type: "RESET" });
  };

  return (
    <aside id="sidebar" className={`sidebar ${role === 4 ? 'admin-sidebar' : ''}`}>
      <ul className={`sidebar-nav ${role === 4 ? 'admin-sidebar-nav' : ''}`} id="sidebar-nav">
        {/* Dashboard  */}
        <li className="nav-item">
          <NavLink className="nav-link" to="dashboard">
            <i className="iconly-Bold-Home"></i>{" "}
            <span>{t('sidebar.dashboard')}</span>
          </NavLink>
        </li>

        {/* Admin Navbar */}
        {(role === 3 || role === 4) && (
          <>
            <li className="nav-item">
              {/* Parents Nav */}
              <NavLink className={({ isActive }) => isActive || location.pathname.includes("parent") ? "nav-link active" : "nav-link"} to="parents">
                <i className="iconly-Bold-People"></i>{" "}
                <span>{t('sidebar.parents')}</span>
              </NavLink>
            </li>

            {/* Childern Nav, only for role 3 */}
            {role === 4 && (
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive || location.pathname.includes("children") ? "nav-link active" : "nav-link"} to="children">
                  <i className="fa-solid fa-children"></i>{" "}
                  <span>{t('sidebar.children')}</span>
                </NavLink>
              </li>
            )}

            <li className="nav-item">
              {/* Physician Nav */}
              <NavLink className={({ isActive }) => isActive || location.pathname.includes("physician") ? "nav-link active" : "nav-link"} to="physician">
                <i className="iconly-Bold-TwoUsers"></i>{" "}
                <span>{t('sidebar.physician')}</span>
              </NavLink>
            </li>
            
            {role === 4 && (
              <li className="nav-item">
                {/*  Appointments Nav */}
                <NavLink className="nav-link" to="appointments">
                  <i className="iconly-Bold-Calendar" />{" "}
                  <span>{t('sidebar.appointments')}</span>
                </NavLink>
              </li>
            )}

            {/* Hospital Nav, only for role 3 */}
            {role === 3 && (
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive || location.pathname.includes("hospital") ? "nav-link active" : "nav-link"} to="hospital">
                  <i className="iconly-Bold-Plus"></i>{" "}
                  <span>{t('sidebar.hospital')}</span>
                </NavLink>
              </li>
            )}
          </>
        )}

        {/* Physician Navbar */}
        {role === 2 && (
          <>
            <li className="nav-item">
              {/* Development Nav */}
              <NavLink className={({ isActive }) => isActive || location.pathname.includes("development") ? "nav-link active" : "nav-link"} to="development">
                <i className="iconly-Bold-Activity" />{" "}
                <span>{t('sidebar.development')}</span>
              </NavLink>
            </li>
            <li className="nav-item">
              {/* Measurement Nav */}
              <NavLink className={({ isActive }) => isActive || location.pathname.includes("measurement") ? "nav-link active" : "nav-link"} to="measurement">
                <i className="fa-solid fa-weight-scale" style={{ fontSize: "21px" }}></i>{" "}
                <span>{t('sidebar.measurement')}</span>
              </NavLink>
            </li>
            <li className="nav-item">
              {/*  Medical Issues Nav */}
              <NavLink className={({ isActive }) => isActive || location.pathname.includes("medical-issues") ? "nav-link active" : "nav-link"} to="medical-issues">
                <i className="fa-solid fa-hospital-user" />{" "}
                <span>{t('sidebar.medicalIssues')}</span>
              </NavLink>
            </li>
            <li className="nav-item">
              {/*  Parents Nav */}
              <NavLink className="nav-link" to="parent-list">
                <i className="iconly-Bold-People" />{" "}
                <span>{t('sidebar.parents')}</span>
              </NavLink>
            </li>
            <li className="nav-item">
              {/* Vaccination Nav */}
              <NavLink className={({ isActive }) => isActive || location.pathname.includes("vaccination") ? "nav-link active" : "nav-link"} to="vaccination">
                <i className="fa-solid fa-syringe" />{" "}
                <span>{t('sidebar.vaccination')}</span>
              </NavLink>
            </li>
            <li className="nav-item">
              {/*  Appointments Nav */}
              <NavLink className="nav-link" to="appointments">
                <i className="iconly-Bold-Calendar" />{" "}
                <span>{t('sidebar.appointments')}</span>
              </NavLink>
            </li>
          </>
        )}

        
        {(role === 2 || role === 4) && (
            <li className="nav-item">
              {/* Vaccination Schedule Dropdown Toggle */}
              <div
                className="nav-link mb-3"
                onClick={(e) => isOpen && toggleDropdown("vaccinationSchedule", e)}
                style={{ cursor: "pointer" }}
              >
                <i className="fa-solid fa-calendar-check"></i>{" "}
                {isOpen && <span>{t("sidebar.vaccinationSchedule")}</span>}
              </div>

              {/* Dropdown Items */}
              {isOpen && openDropdowns.vaccinationSchedule && (
                <ul className="nav flex-column ms-3">
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) => isActive || location.pathname.includes("upcoming") ? "nav-link active" : "nav-link"}
                      to="upcoming-vaccine"
                    >
                      <span>{t("sidebar.upcomingVaccination")}</span>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) => isActive || location.pathname.includes("missed") ? "nav-link active" : "nav-link"}
                      to="missed-vaccine"
                    >
                      <span>{t("sidebar.missedVaccination")}</span>
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>
          )}

        <li className="nav-item">
          <span onClick={logout} className="nav-link">
            <i className="iconly-Bold-Logout"></i>{" "}
            <span>{t('sidebar.logout')}</span>
          </span>
        </li>
        {/* End Logout Nav */}
      </ul>
    </aside>
  );
}

export default Sidebar;
